import type React from 'react';

/**
 * Color tokens resolve to the per-theme CSS variables defined in
 * live-theme.css (.lw-theme-midnight / -ivory / -emerald), each with a
 * midnight-gold fallback. This makes every `LIVE.*` usage across the watch
 * page theme-reactive automatically — no per-component theming needed.
 */
export const LIVE = {
  gold: 'var(--lw-accent, #C9A962)',
  goldBright: 'var(--lw-accent-2, #E8C25A)',
  goldPale: 'var(--lw-accent-2, #F4D06F)',
  goldDim: 'var(--lw-card, rgba(201,169,98,0.14))',
  goldBorder: 'var(--lw-border, rgba(201,169,98,0.28))',
  goldBorderStrong: 'var(--lw-border, rgba(201,169,98,0.5))',
  bgVoid: 'var(--lw-bg, #080808)',
  bgDeep: 'var(--lw-bg, #0a0a0a)',
  bgCard: 'var(--lw-card, #0f0e09)',
  bgRaised: 'var(--lw-bg-2, #141310)',
  textBody: 'var(--lw-text, rgba(255,255,255,0.74))',
  textMuted: 'var(--lw-text-muted, rgba(255,255,255,0.40))',
  live: '#e82f2f',
} as const;

export const goldGrad = `linear-gradient(135deg, ${LIVE.gold} 0%, ${LIVE.goldBright} 55%, ${LIVE.goldPale} 100%)`;

export const pageDarkGrad = `linear-gradient(135deg, #0a0a0a 0%, #0f0e09 50%, #0a0a0a 100%)`;

export const goldGradText: React.CSSProperties = {
  background: goldGrad,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text',
};

export const LIVE_THEMES = [
  { id: 'midnight', name: 'Midnight Gold',  swatch: ['#0a0a0a', '#c9a962'] },
  { id: 'ivory',    name: 'Ivory & Blush',  swatch: ['#faf6f0', '#b76e79'] },
  { id: 'emerald',  name: 'Emerald & Gold', swatch: ['#08201a', '#d9b45b'] },
  { id: 'crimson',  name: 'Crimson Silk',   swatch: ['#1c060a', '#e0aa3e'] },
] as const;

export type LiveThemeId = typeof LIVE_THEMES[number]['id'];

export const VALID_THEME_IDS: LiveThemeId[] = ['midnight', 'ivory', 'emerald', 'crimson'];
